import React, {useState, useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import ErrorBoundaryForComponents from './../../../util/ErrorBoundaryForComponents';
import {ThemeContext} from './../../../themes/ThemeProvider';
import WorkQueueSearchTable from './WorkQueueSearchTable';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import * as Yup from 'yup';
const WorkQueueSearch = ({setTabValue, setWorkQueueRowData}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);

  const SearchSessionWorkQueue = JSON.parse(sessionStorage.getItem('WorkQueueActivity'));
  const initialValues = {
    workQueueCode: '',
    userName: '',
    workStartDttm: null,
    accountsOpened: '',
    accountsWorked: '',
    lastUpdatedDttm: null,
  };
  const validationSchema = Yup.object().shape({
    workStartDttm: Yup.date().typeError('Invalid date format').nullable(),
  });
  const onClear = () => {
    const data = {
      workQueueCode: '',
      userName: '',
      workStartDttm: null,
      accountsOpened: '',
      accountsWorked: '',
      lastUpdatedDttm: null,
    };
    setSearchData(data);
    setSubmit(true);
    sessionStorage.removeItem('WorkQueueActivity');
  };

  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
    sessionStorage.setItem('WorkQueueActivity', JSON.stringify(data));
  };

  return (
    <div>
      <h2 className="search-title">Work Queue Activity Search</h2>
      <Formik
        onSubmit={handleSubmit}
        initialValues={SearchSessionWorkQueue ? SearchSessionWorkQueue : initialValues}
        enableReinitialize
        validationSchema={validationSchema}
      >
        {(props) => {
          const {values, handleChange, handleBlur, errors, touched, setFieldValue, handleReset} =
            props;

          return (
            <Form autoComplete="off" noValidate>
              <ErrorBoundaryForComponents>
                <div className="form-row standard-field-textfields new-standard-textfields">
                  <div className="col-xs-4 col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group">
                    <TextField
                      className={`${classes.labelName}`}
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Work Queue Name`}
                      label="Work Queue Name"
                      name="workQueueCode"
                      value={values?.workQueueCode?.toUpperCase()}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.workQueueCode}
                      error={Boolean(touched.workQueueCode && errors.workQueueCode)}
                    />
                    <FormHelperText>
                      {touched.workQueueCode && errors.workQueueCode && errors.workQueueCode}
                    </FormHelperText>
                  </div>
                  <div className="col-xs-4 col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                    <TextField
                      className={`${classes.labelName}`}
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter User Name`}
                      label="User Name"
                      name="userName"
                      value={values.userName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group start-enddate">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        className={`${classes.labelName}`}
                        format="MM/dd/yyyy"
                        placeholder="MM/DD/YYYY"
                        fullWidth
                        value={values.workStartDttm}
                        name="workStartDttm"
                        onBlur={handleBlur}
                        inputVariant="outlined"
                        helperText=""
                        label="Start Date"
                        onChange={(val) => {
                          setFieldValue('workStartDttm', val);
                        }}
                        autoOk
                        margin="dense"
                        touched={touched?.workStartDttm}
                        error={Boolean(touched?.workStartDttm && errors?.workStartDttm)}
                      />
                    </MuiPickersUtilsProvider>
                    <FormHelperText variant="outlined">
                      {touched.workStartDttm && errors.workStartDttm ? errors.workStartDttm : ''}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group start-enddate">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        className={`${classes.labelName}`}
                        format="MM/dd/yyyy"
                        placeholder="MM/DD/YYYY"
                        fullWidth
                        value={values.lastUpdatedDttm}
                        name="lastUpdatedDttm"
                        onBlur={handleBlur}
                        inputVariant="outlined"
                        helperText=""
                        label="End Date"
                        onChange={(val) => {
                          setFieldValue('lastUpdatedDttm', val);
                        }}
                        autoOk
                        margin="dense"
                        touched={touched?.lastUpdatedDttm}
                        error={Boolean(touched?.lastUpdatedDttm && errors?.lastUpdatedDttm)}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className="col-xs-4 col-sm-6 col-md-4 col-lg-12 col-xl-3 form-group">
                    <div className="d-flex align-items-center justify-content-md-center justify-content-xl-start">
                      <Button
                        variant="outlined"
                        type="reset"
                        className={`mr-1 reset-btn ${classes.buttonRoot}`}
                        onClick={() => {
                          handleReset();
                          onClear();
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                      >
                        Search
                      </Button>
                    </div>
                  </div>
                </div>
              </ErrorBoundaryForComponents>
            </Form>
          );
        }}
      </Formik>
      <WorkQueueSearchTable
        setTabValue={setTabValue}
        searchData={searchData}
        setSubmit={setSubmit}
        submit={submit}
        setSearchData={setSearchData}
        setWorkQueueRowData={setWorkQueueRowData}
      />
    </div>
  );
};

export default WorkQueueSearch;
